/**
 * Number of applications by five underwriting/ re-underwriting results, by age and sex of Insured Person
 */
import { hasLoadings, hasExclusions } from "@/modules/reports/schemas/utils/"
import get from "lodash.get"
import dayjs from "dayjs"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 3, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 3, c: 1 }
		},
		{
			s: { r: 1, c: 2 },
			e: { r: 1, c: 9 }
		},
		{
			s: { r: 1, c: 10 },
			e: { r: 1, c: 17 }
		},
		{
			s: { r: 2, c: 2 },
			e: { r: 2, c: 3 }
		},
		{
			s: { r: 2, c: 4 },
			e: { r: 2, c: 5 }
		},
		{
			s: { r: 2, c: 6 },
			e: { r: 2, c: 7 }
		},
		{
			s: { r: 2, c: 8 },
			e: { r: 2, c: 9 }
		},
		{
			s: { r: 2, c: 10 },
			e: { r: 2, c: 11 }
		},
		{
			s: { r: 2, c: 12 },
			e: { r: 2, c: 13 }
		},
		{
			s: { r: 2, c: 14 },
			e: { r: 2, c: 15 }
		},
		{
			s: { r: 2, c: 16 },
			e: { r: 2, c: 17 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template A1 - Number of accepted/rejected offer of customers by four Underwriting/ Re-underwriting results, by age and sex of Insured Person"
	],
	["Age", "Sex", "Standard Plan", "", "", "", "", "", "", "", "Flexi Plan"],
	[
		"",
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading Only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		"",
		"Standard Offer",
		"",
		"Offer with Premium Loading Only",
		"",
		"Offer with CBE only",
		"",
		"Offer with Premium Loading and CBE",
		""
	],
	[
		"",
		"",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject",
		"Accept",
		"Reject"
	]
]

// Return calculated age
const getAge = policy => {
	const dateOfBirth = get(policy, "insured[0].dateOfBirth", null)
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	for (let i = 1; i < 100; i++) {
		output.push([
			i,
			"M",
			countStandardOffer(i, "male", payload, "QUOTING"),
			countStandardOffer(i, "male", payload, "REJECTED"),
			countOfferWithLoadings(i, "male", payload, "QUOTING"),
			countOfferWithLoadings(i, "male", payload, "REJECTED"),
			countOfferWithExclusions(i, "male", payload, "QUOTING"),
			countOfferWithExclusions(i, "male", payload, "REJECTED"),
			countOfferWithLoadingsAndExclusions(i, "male", payload, "QUOTING"),
			countOfferWithLoadingsAndExclusions(i, "male", payload, "REJECTED")
		])
	}
	for (let j = 1; j < 100; j++) {
		output.push([
			j,
			"F",
			countStandardOffer(j, "female", payload, "QUOTING"),
			countStandardOffer(j, "female", payload, "REJECTED"),
			countOfferWithLoadings(j, "female", payload, "QUOTING"),
			countOfferWithLoadings(j, "female", payload, "REJECTED"),
			countOfferWithExclusions(j, "female", payload, "QUOTING"),
			countOfferWithExclusions(j, "female", payload, "REJECTED"),
			countOfferWithLoadingsAndExclusions(j, "female", payload, "QUOTING"),
			countOfferWithLoadingsAndExclusions(j, "female", payload, "REJECTED")
		])
	}
	return output
}

const countStandardOffer = (age, gender, payload, status) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)

		if (
			policy.status === status &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings === false &&
			exclusions === false
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadings = (age, gender, payload, status) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)

		if (
			policy.status === status &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings === true &&
			exclusions === false
		) {
			return policy
		}
	}).length
}

const countOfferWithExclusions = (age, gender, payload, status) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		let exclusions = hasExclusions(policy)
		let loadings = hasLoadings(policy)
		if (
			policy.status === status &&
			insuredAge === age &&
			insuredGender === gender &&
			exclusions === true &&
			loadings === false
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadingsAndExclusions = (age, gender, payload, status) => {
	return payload.filter(policy => {
		let insuredAge = getAge(policy)
		let insuredGender = get(policy, "insured[0].gender", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === status &&
			insuredAge === age &&
			insuredGender === gender &&
			loadings &&
			exclusions
		) {
			return policy
		}
	}).length
}
